<footer class="site-footer" dir="rtl">

  <div class="footer-main">

    <div class="footer-brand">
      <div class="footer-logo">
        <span class="footer-logo-badge"><i class="fa fa-tag"></i></span>
        <span class="footer-logo-word">Sale4<span class="accent-part">ALL</span></span>
      </div>
      <p class="footer-tagline">פלטפורמת המכירות של ישראל — קונים ומוכרים הכל, בכל מקום.</p>
    </div>

    <div class="footer-col">
      <h3>ניווט מהיר</h3>
      <a routerLink="/">דף הבית</a>
      <a routerLink="/publish">פרסום מודעה</a>
      <a routerLink="/personal">האזור האישי</a>
      <a routerLink="/personal/wishlist">מועדפים</a>
      <a routerLink="/cart">עגלת קניות</a>
    </div>

    <div class="footer-col">
      <h3>קטגוריות</h3>
      <a routerLink="/shop/car">רכב</a>
      <a routerLink="/shop/nadlan">נדל"ן</a>
      <a routerLink="/shop/sale2">יד שנייה</a>
      <a routerLink="/shop/teacher">מורים</a>
      <a routerLink="/shop/pet">חיות מחמד</a>
    </div>

    <div class="footer-col">
      <h3>מידע</h3>
      <a routerLink="/about">אודות</a>
      <a routerLink="/contact">צור קשר</a>
      <a routerLink="/privacy">פרטיות</a>
      <a routerLink="/terms">תנאי שימוש</a>
      <a href="/assets/readabler/accessibility-statement.html" target="_blank" rel="noopener">הצהרת נגישות</a>
    </div>

  </div>

  <div class="footer-confidence" aria-label="מידע לקנייה בטוחה">
    <div><i class="fa fa-shield" aria-hidden="true"></i><span><strong>שומרים עליכם</strong><small>אל תעבירו תשלום לפני שבדקתם את המוצר והמפרסם</small></span></div>
    <a routerLink="/terms">טיפים לעסקה בטוחה <span aria-hidden="true">←</span></a>
  </div>

  <div class="footer-bottom">
    <div class="footer-bottom-inner">
      <p>© {{ currentYear }} Sale4ALL — כל הזכויות שמורות</p>

      <div class="footer-bottom-right">
        <div class="footer-bottom-links">
          <a routerLink="/privacy">פרטיות</a>
          <span class="dot">·</span>
          <a routerLink="/terms">תנאי שימוש</a>
          <span class="dot">·</span>
          <a href="/assets/readabler/accessibility-statement.html" target="_blank" rel="noopener">הצהרת נגישות</a>
        </div>
        <button type="button" class="back-to-top" (click)="scrollToTop()" aria-label="חזרה לראש העמוד">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 19V5M5 12l7-7 7 7"/>
          </svg>
          <span>למעלה</span>
        </button>
      </div>
    </div>
  </div>

</footer>
